import React from "react";

interface InAppAdsCardProps {
  iconSrc: string;
  title: string;
  paragraph: string;
  onClick: () => void;
  style?: React.CSSProperties;
}

export const InAppAdsCard: React.FC<InAppAdsCardProps> = ({
  iconSrc,
  title,
  paragraph,
  onClick,
  style,
}) => {
  return (
    <div className="InAppAds-card" onClick={onClick} style={style}>
      <div className="image-container">
        <img src={iconSrc} alt="Cover" className="cover-image" />
      </div>
      <div className="content-container">
        <h2 className="title">{title}</h2>
        <p className="paragraph">{paragraph}</p>
      </div>

      <style>{`
        .InAppAds-card {
          background-color: #f5f2eb;
          border-radius: 16px;
          display: flex;
          flex-direction: column;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          font-family: 'Albra', sans-serif;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          height: 150px; 
          overflow: hidden;
          position: relative;
          padding: 0; 
        }

        .InAppAds-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }

        .InAppAds-card::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: linear-gradient(90deg, #c08267, #e6a27c);
        }
        
        .image-container {
          width: 100%;
          height: 50px;
          overflow: hidden;
        }

        .cover-image {
          width: 100%;
          height: 50px;
          object-fit: cover;
          display: block;
        }

        .content-container {
          width: 100%;
          text-align: center;
          padding: 10px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          overflow: hidden;
        }

        .title {
          font-size: 18px;
          font-weight: 600;
          margin: 0 0 8px;
          line-height: 1.3;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-family: 'Albra', sans-serif;
        }

        .paragraph {
          font-size: 14px;
          color: #666;
          margin: 0;
          line-height: 1.5;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3; /* Limit to 3 lines */
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          font-family: 'europa', sans-serif;
        }
      `}</style>
    </div>
  );
};
